<template>
  <div>
    <div
      v-for="item in items"
      :key="item.id"
      class="flex justify-between py-m border-b border-shadow-color"
    >
      <div class="font-medium text-lg">
        {{ item.title }}
      </div>
      <router-link
        :to="item.action.to"
        class="text-grey cursor-pointer text-lg cursor-pointer"
      >
        {{ item.action.title }}
      </router-link>
    </div>
    <div
      v-if="hasAddListener"
      class="font-medium text-lg text-orange pt-4 pl-2 cursor-pointer"
      @click="$emit('add')"
    >
      <Plus class="mr-2" />
      {{ addTitle }}
    </div>
  </div>
</template>

<script>
import Plus from './icons/Plus.vue';

export default {

  name: 'BaseEditableList',
  components: {
    Plus,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    addTitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    hasAddListener() {
      return this.$listeners && this.$listeners.add;
    },
  },
};
</script>

<style lang="css" scoped>
</style>
